import { Outlet } from "react-router-dom";
import { Container } from "@mui/material";
import FetchingIndicator from "./FetchingIndicator";
import AppBar from "./components/AppBar";
import "./App.css";
import { AlertProvider } from "components/AlertContext";
import AlertPopup from "components/AlertPopup";
import { useTranslation } from "react-i18next";

const App = () => {
  const { t } = useTranslation();

  return (
    <>
      <AlertProvider>
        <a href="#main-content" className="skip-link">
          {t("a11y.skipToMainContent")}
        </a>
        <FetchingIndicator />
        <AppBar />
        <Container component="main" id="main-content" tabIndex={-1} sx={{ mt: 4 }}>
          <Outlet />
        </Container>
        <AlertPopup />
      </AlertProvider>
    </>
  );
};
export default App;
